import { useState } from "react";
import Tabs from "../../../../../../../library/tabs";
import Animation from "./animation";
import Appearance from "./appearance";

const TextSettings = () => {
  const [activeTab, setActiveTab] = useState<string>("appearance");
  const SELECTIONS = [
    {
      id: 0,
      key: "appearance",
      title: "Utseende",
      ariaLabel: "Utseende",
      display: <Appearance />,
    },
    {
      id: 1,
      key: "shared",
      title: "Animasjon",
      ariaLabel: "Animasjon",
      display: <Animation />,
    },
  ];

  return (
    <Tabs
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      selections={SELECTIONS}
      variant="primary"
    />
  );
};

export default TextSettings;
